export { default } from './EzSpinner.vue';
